module.exports = __webpack_public_path__ + "img/img05.cb20ae80.png";